export default "__VITE_ASSET__B52UB5O3__"